module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/readable-stream/transform.js
 ** module id = 297
 ** module chunks = 46 47
 **/